// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__EfWaF","header":"PatientQuestionnaire_header__bViG1","info":"PatientQuestionnaire_info__3mtuN"};